import { useMemo } from 'react'

import 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsDocuments/ContractVersionHistory/styles.scss'
import { Attachment } from 'components/Attachment/Attachment'
import { fileNameFormatter } from 'helper/common'
import { useContractDetailsContext } from 'features/ContractDetails/Providers/ContractDetailsContextProvider'
import { TRFPDocument } from 'features/RFP/RFPDetails/types'

type TContractVersionHistoryProps = {
  documents?: TRFPDocument[]
}

const ContractVersionHistory = ({
  documents
}: TContractVersionHistoryProps) => {
  const contractDetailsContext = useContractDetailsContext()

  const { contractDocuments } = contractDetailsContext.state

  const Documents = useMemo(
    () =>
      (documents ?? contractDocuments ?? []).map((document, idx) => (
        <div
          className="contract-version-history__document"
          key={document.uuid || idx}
        >
          <div className="contract-version-history__node" />
          <Attachment
            link={document.file}
            user={document.creator}
            createdAt={document.created_at}
            filename={fileNameFormatter(document.file)}
            showDetails
            disableActions
          />
        </div>
      )),
    [contractDocuments, documents]
  )

  return <div className="contract-version-history">{Documents}</div>
}

export default ContractVersionHistory
